export const CHART_COLORS = {
  orange: "#F37020",
  blue: "#3B82F6",
  emerald: "#10B981",
  violet: "#8B5CF6",
  cyan: "#06B6D4",
  red: "#EF4444",
  amber: "#F59E0B",
}

export const CHART_PALETTE = [
  CHART_COLORS.orange,
  CHART_COLORS.blue,
  CHART_COLORS.emerald,
  CHART_COLORS.violet,
  CHART_COLORS.cyan,
  CHART_COLORS.amber,
  CHART_COLORS.red,
]

export const AXIS_STYLE = {
  stroke: "#2A2A3A",
  fontSize: 11,
  fontFamily: "'IBM Plex Mono', monospace",
  tickLine: false,
  axisLine: false,
}

export const GRID_STYLE = {
  stroke: "#1E1E2A",
  strokeDasharray: "3 3",
}

export const TOOLTIP_STYLE = {
  contentStyle: {
    background: "#1A1A23",
    border: "1px solid #2A2A3A",
    borderRadius: "8px",
    fontSize: "12px",
    fontFamily: "'IBM Plex Mono', monospace",
    color: "#E4E4E7",
    boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
  },
  itemStyle: {
    color: "#A1A1AA",
    fontSize: "11px",
  },
  labelStyle: {
    color: "#E4E4E7",
    fontWeight: 600,
    marginBottom: "4px",
  },
}
